import { render, staticRenderFns } from "./AppLanguage.vue?vue&type=template&id=23d2d0c6"
import script from "./AppLanguage.vue?vue&type=script&lang=ts"
export * from "./AppLanguage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports